<div class="modal-backdrop fade show"></div>

<div class="modal d-block">
  <div class="modal-dialog modal-xl">
    <div class="modal-content">

      <div class="modal-header">
        <h5 class="modal-title">
          {{ participant ? 'Modifier' : 'Ajouter' }} un participant
        </h5>
        <button class="btn-close" (click)="close.emit()"></button>
      </div>

      <div class="modal-body">
        <form [formGroup]="form">
          <div class="row">

            <!-- Identité -->
            <div class="col-lg-12 mb-3">
              <input class="form-control" [class.is-invalid]="isInvalid('fullName')" placeholder="Nom et prénom *"
                formControlName="fullName">

              <div class="invalid-feedback">
                {{ getError('fullName') }}
              </div>
            </div>

            <div class="row align-items-center mb-3">

              <!-- Label Date de naissance -->
              <div class="col-lg-2">
                <label class="form-label fw-semibold mb-0">
                  Date de naissance *
                </label>
              </div>

              <!-- Champ Date -->
              <div class="col-lg-4">
                <input type="date" class="form-control" [class.is-invalid]="isInvalid('birthDate')" formControlName="birthDate">
                <div class="invalid-feedback">
                  {{ getError('birthDate') }}
                </div>
              </div>

              <!-- Champ Ville -->
              <div class="col-lg-5">
                <input class="form-control" placeholder="Ville de résidence" formControlName="city">
              </div>

            </div>

            <!-- Contact -->
            <div class="col-lg-6 mb-3">
              <input class="form-control" [class.is-invalid]="isInvalid('phone')" placeholder="Téléphone (WhatsApp) *" formControlName="phone">

              <div class="invalid-feedback">
                {{ getError('phone') }}
              </div>
            </div>

            <div class="col-lg-6 mb-3">
              <input class="form-control" [class.is-invalid]="isInvalid('email')" placeholder="Email *"
                formControlName="email">

              <div class="invalid-feedback">
                {{ getError('email') }}
              </div>
            </div>

            <!-- Statut -->
            <div class="col-lg-6 mb-3">
              <select class="form-control" [class.is-invalid]="isInvalid('status')" formControlName="status">
                <option value="">Statut *</option>
                <option *ngFor="let s of statuses" [value]="s">
                  {{ s }}
                </option>
              </select>
              
              <div class="invalid-feedback">
                {{ getError('status') }}
              </div>
            </div>

            <!-- Académique -->
            <div class="col-lg-6 mb-3">
              <input class="form-control" placeholder="École / Université *" formControlName="school">
              <div class="invalid-feedback">
                {{ getError('school') }}
              </div>
            </div>

            <div class="col-lg-6 mb-3">
              <input class="form-control" placeholder="Niveau d’étude *" formControlName="educationLevel">
              <div class="invalid-feedback">
                {{ getError('educationLevel') }}
              </div>
            </div>

            <!-- <div class="col-lg-6 mb-3">
              <input type="number" class="form-control" placeholder="Année de diplôme" formControlName="graduateYear">
            </div> -->

            <!-- ARCHI_GRADUATE -->
            <div class="col-lg-12 mb-3" *ngIf="form.value.status === ParticipantStatus.ARCHI_GRADUATE">
              <label class="fw-semibold">Diplôme (PDF)</label>
            
              <!-- FICHIER EXISTANT -->
              <div *ngIf="existingDiplomaFile; else uploadNewDiploma"
                class="alert alert-secondary d-flex align-items-center justify-content-between">
            
                <div>
                  <i class="icofont-file-pdf text-danger me-2"></i>
                  <strong>Fichier actuel :</strong>
                  {{ existingDiplomaFile | slice:existingDiplomaFile.lastIndexOf('/') + 1 }}
                </div>
            
                <div>
                  <!-- <a class="btn btn-outline-primary btn-sm me-2" [href]="existingDiplomaFile" target="_blank">
                    Voir
                  </a> -->
            
                  <button type="button" class="btn btn-outline-danger btn-sm" (click)="removeDiplomaFile()">
                    Remplacer
                  </button>
                </div>
              </div>
            
              <!-- UPLOAD NOUVEAU -->
              <ng-template #uploadNewDiploma>
                <input type="file" accept="application/pdf" class="form-control" [class.is-invalid]="isInvalid('diplomaFile')"
                  (change)="onFileChange($event)">
            
                <div class="invalid-feedback">
                  {{ getError('diplomaFile') }}
                </div>
              </ng-template>
            </div>

            <!-- AUTRES STATUTS -->
            <div class="col-lg-12 mb-3"
              *ngIf="form.value.status && form.value.status !== ParticipantStatus.ARCHI_GRADUATE">
              <input class="form-control" placeholder="Numéro matricule *" formControlName="matriculeNumber">
            </div>

          </div>
        </form>
      </div>

      <div class="modal-footer">
        <button class="btn btn-secondary" (click)="close.emit()">Annuler</button>
        <button class="btn btn-primary" [disabled]="form.invalid" (click)="submit()">
          Enregistrer
        </button>
      </div>

    </div>
  </div>
</div>